export default __webpack_public_path__ + "static/media/5.b86c1493.png";